import { Tooltip as BitsTooltip } from 'bits-ui';

export { default as ToolTip } from './ToolTip.svelte';

export const ToolTipProvider = BitsTooltip.Provider;
